/* eslint-disable eqeqeq,no-param-reassign,no-var,vars-on-top */

xplenty.service('confirmationDialog', [
  'ngDialog',
  '$translate',
  function (ngDialog, $translate) {
    const defaults = {
      title: $translate.instant('confirmation-dialog.title'),
      hint: $translate.instant('confirmation-dialog.hint'),
      yes: $translate.instant('confirmation-dialog.actions.yes'),
      no: $translate.instant('confirmation-dialog.actions.no'),
      type: 'danger', // one of 'danger', 'success', 'info', 'warning'
      itemState: 'pending_removal', // one of 'removal', 'default'
      clustercat: false,
    };
    return function (options, yes, no) {
      if (options instanceof Function) {
        no = yes;
        yes = options;
        options = {};
      }

      const settings = _.extend({}, defaults, options);

      const snippetableItemTypes = [
        'packages',
        'connections',
        'hooks',
        'schedules',
        'members',
        'keys',
        'jobs',
        'accounts',
      ];

      if (settings.item) {
        settings.item[settings.itemState] = true;
      }
      var dialog = ngDialog.open({
        closeByNavigation: true,
        // eslint-disable-next-line global-require
        template: require('../../../views/dialogs/confirm.html'),
        plain: true,
        controller: [
          '$scope',
          function ($scope) {
            $scope.settings = settings;
            $scope.isSnippetPresent = function () {
              return settings.item && settings.itemType && _.contains(snippetableItemTypes, settings.itemType);
            };
            $scope.no = function () {
              dialog.close();
            };
            $scope.yes = function () {
              dialog.close('yes');
            };
          },
        ],
      });

      dialog.closePromise.then(function (data) {
        if (settings.item) {
          settings.item[settings.itemState] = false;
        }
        if (data.value == 'yes') {
          if (yes) yes();
        } else if (no) no();
      });
    };
  },
]);
